import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { useFormik } from 'formik'
import { validationSchema } from './helpers'
import { useMutation } from 'react-query'
import { useNotification } from 'hooks'
import { handleQueryError } from 'utils/helpers'
import { FormInfoItems } from 'components/core-ui/FormInfoItems'
import { makeCorePostRequest } from 'utils/api'
import { FileUpload } from 'components/core-ui/FileUpload'
import { ChangeEvent } from 'react'
import { toBlobFormDataPayload, toFormDataPayload } from 'utils/serializers'
import { useOfflineTool } from 'components/core-ui/Offline'
import { AxiosError } from 'axios'

const EditPackagingInventory = ({ isModalOpen, closeModal, editItem, setShouldRefreshData }) => {
  const { showNotification } = useNotification()

  const offlineTool = useOfflineTool()

  const uploadImage = async (values: any) => {
    await makeCorePostRequest(
      `/shop-reception/support-inventories/inventory/${editItem.id}?intact=${formik.values.intact}&defect=${formik.values.defect}`,
      values,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  const { isLoading, mutate } = useMutation(uploadImage, {
    onSuccess: () => {
      setShouldRefreshData(true)
      closeModal()
      formik.resetForm()
      showNotification({
        message: 'Inventarul a fost actualizat cu succes.',
        type: 'success'
      })
    },
    onError: (err: any) => {
      if (err?.code === AxiosError.ERR_NETWORK) {
        showNotification({
          message: 'Verificati conexiunea la internet',
          type: 'error'
        })

        // Store offline
        offlineTool.addOwnTask({
          type: `Inventar ambalaje`,
          data: err.config.data as FormData,
          url: `/shop-reception/support-inventories/inventory/${editItem.id}?intact=${formik.values.intact}&defect=${formik.values.defect}`,
          method: 'post'
        })

        closeModal()

        return
    }}
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      intact: editItem?.intactNumber,
      defect: editItem?.brokenNumber,
      file: null
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      const payload = toBlobFormDataPayload(values)
      mutate(payload)
    }
  })

  const onFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files[0]
    formik.setFieldValue('file', file)
  }

  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal} modalTitle="Actualizare inventar">
      <Grid container spacing={4}>
        <Grid xs={12} item>
          <FormInfoItems
            items={[
              editItem?.shopName && { label: 'Magazin:', name: editItem?.shopName },
              editItem?.hubName && { label: 'HUB:', name: editItem?.hubName },
              { label: 'Tip suport:', name: editItem?.supportType }
            ]}
          />
        </Grid>
        <Grid xs={12} item>
          <Input
            type="number"
            name="intact"
            label="Calitativ"
            fullWidth
            variant="outlined"
            value={formik.values.intact}
            onChange={event => formik.setFieldValue('intact', event.currentTarget.value)}
            error={!!formik.errors.intact}
            helperText={formik.errors.intact as string}
            required
          />
        </Grid>
        <Grid xs={12} item>
          <Input
            type="number"
            name="defect"
            label="Defect"
            fullWidth
            variant="outlined"
            value={formik.values.defect}
            onChange={event => formik.setFieldValue('defect', event.currentTarget.value)}
            error={!!formik.errors.defect}
            helperText={formik.errors.defect as string}
            required
          />
        </Grid>
        {formik.values.defect !== editItem?.brokenNumber && formik.values.defect > 0 && (
          <Grid item xs={12}>
            <div style={{ width: '300px' }}>
              <FileUpload
                value={null}
                fileInputProps={{
                  displayImage: ''
                }}
                onChange={onFileUpload}
              />
            </div>
          </Grid>
        )}
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={() => closeModal()} />
          <Button
            variant="contained"
            label="Salveaza"
            onClick={() => formik.handleSubmit()}
            disabled={isLoading || (formik.values.defect !== editItem?.brokenNumber &&
              formik.values.defect > 0 &&
              !formik.values.file)}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default EditPackagingInventory
